// Framework-neutral footer source (Spec 30 F1). Plain TS — no React, no Astro —
// so both the marketing (Astro) and app (React) footers render the SAME
// structure + content in their own palette. Change a legal link once here and
// both footers update; the drift the marketing footer used to own alone is dead.
//
// Note on hrefs: the sitemap variants and the legal links are authored as the
// marketing site's own relative paths. The editorial (marketing) renderer uses
// them as-is; the streaming (app) renderer resolves the marketing-owned links
// (legal, Articles) against the marketing origin, since those pages live on the
// marketing site, not the app.

import { BRAND } from '../brand/constants';

export interface FooterLink {
  label: string;
  href: string;
  external?: boolean;
}

/** The brand block content (each surface renders the wordmark with its own component). */
export const footerBrand = {
  etymology: BRAND.etymology,
  tagline: BRAND.tagline,
} as const;

/** Editorial (parchment) sitemap — today's marketing footer links, unchanged. */
export const editorialSitemap: { heading: string; links: FooterLink[] } = {
  heading: 'Sitemap',
  links: [
    { label: 'About', href: '/about' },
    { label: 'FAQ', href: '/faq' },
    { label: 'Membership', href: '/membership' },
    { label: 'Masthead', href: '/masthead' },
    { label: 'Corrections', href: '/corrections' },
    { label: 'Search', href: '/search' },
    { label: 'RSS', href: '/rss.xml' },
  ],
};

/** Streaming (dark) sitemap — the approved video-surface set (Spec 30 confirm 1). */
export const streamingSitemap: { heading: string; links: FooterLink[] } = {
  heading: 'Browse',
  links: [
    // No dedicated routes exist; these resolve to sections on BrowsePage (/).
    { label: 'Live now', href: '/#live-now' },
    { label: 'Categories', href: '/#categories' },
    { label: 'Articles', href: `https://${BRAND.domain}`, external: true },
    { label: 'Donate', href: '/donate' },
  ],
};

/** Legal + contact column — shared by both surfaces (same links, same emails). */
export const legalLinks: FooterLink[] = [
  { label: 'Terms of Service', href: '/legal/terms' },
  { label: 'Privacy Policy', href: '/legal/privacy' },
  { label: 'Contributor Agreement', href: '/legal/contributor-agreement' },
];

export const contactEmails: readonly string[] = [
  BRAND.emails.editorial,
  BRAND.emails.contributors,
  BRAND.emails.corrections,
];

export const legalHeading = 'Legal & Contact';

export function footerCopyright(year: number): string {
  return `© ${year} ${BRAND.name}. All rights reserved.`;
}
